import { render, staticRenderFns } from "./echars-data.vue?vue&type=template&id=2bd6ca5f&scoped=true&"
import script from "./echars-data.vue?vue&type=script&lang=js&"
export * from "./echars-data.vue?vue&type=script&lang=js&"
import style0 from "./echars-data.vue?vue&type=style&index=0&id=2bd6ca5f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd6ca5f",
  null
  
)

export default component.exports